var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.726 16.16H5.273a.954.954 0 01-.953-.953V6.774c0-.527.427-.954.953-.954h13.453c.527 0 .954.427.954.954v8.433a.954.954 0 01-.954.953z",
    stroke: "#666",
    fill: "#666",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    strokeLinecap: "round",
    d: "M9.76 18.748h4.89v-2.56H9.76zM6.478 18.763h10.706"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.32 12.792h15.36",
    fill: "#FFF"
  }))));
}
export default SvgTv;